(function () {
  function initAboutPage(page) {
    if (page.dataset.aboutPageInit === 'true') return;
    page.dataset.aboutPageInit = 'true';

    var MOBILE_BP = 768;

    function handleResize() {
      var vw = document.documentElement.clientWidth;
      if (vw <= MOBILE_BP) {
        page.style.width = '100%';
        page.style.zoom = '1';
        document.documentElement.classList.add('is-mobile');
      } else {
        document.documentElement.classList.remove('is-mobile');
        if (vw < 1920) {
          page.style.width = '1920px';
          page.style.zoom = vw / 1920;
        } else {
          page.style.width = '100%';
          page.style.zoom = '1';
        }
      }
    }

    handleResize();
    window.addEventListener('resize', handleResize);

    var fadeEls = page.querySelectorAll('.fade-in');
    if (fadeEls.length && 'IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.12 });

      fadeEls.forEach(function (el) {
        observer.observe(el);
      });
    }

    function bindModal(openSelector, modal) {
      if (!modal) return;

      function openModal() {
        modal.classList.remove('hidden');
        document.body.style.overflow = 'hidden';
      }

      function closeModal() {
        modal.classList.add('hidden');
        document.body.style.overflow = '';
      }

      page.querySelectorAll(openSelector).forEach(function (btn) {
        btn.addEventListener('click', openModal);
      });

      var overlayBg = modal.querySelector('.modal-overlay-bg');
      var closeBtn = modal.querySelector('.modal-close');
      var card = modal.querySelector('.modal-card');

      if (overlayBg) overlayBg.addEventListener('click', closeModal);
      if (closeBtn) closeBtn.addEventListener('click', closeModal);
      if (card) {
        card.addEventListener('click', function (e) {
          e.stopPropagation();
        });
      }
    }

    bindModal('.leader-more-ceo', page.querySelector('[data-ceo-modal]'));
    bindModal('.leader-more-cto', page.querySelector('[data-cto-modal]'));
  }

  function boot() {
    document.querySelectorAll('[data-about-page]').forEach(initAboutPage);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var page = event.target.querySelector('[data-about-page]');
    if (page) initAboutPage(page);
  });
})();
